import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Plot from "react-plotly.js";
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function Likelihood(props: Props) {
    const colorGray = 'rgba(140,140,140,1)';
    const colorWhite = 'rgba(255,255,255,1)';
    const colorYellow = 'rgba(255,255,140,1)';
    const colorRed = 'rgba(255,140,140,1)';
    
    let layout_eigen_init = {
        height: 200,
        title: {
            text: 'Likelihood of Interference Sources',
            font: {
                color: 'white',
                size: 12
            }
        },
        margin: {
            l: 50,
            r: 30,
            b: 40,
            t: 30,
            pad: 0
        },
        showlegend: true,
        legend: {
            font: {color: 'white'}
        },
        xaxis: {
            title: {
                text: 'Number of Interference Sources',
                font: {
                    color: 'white'
                }
            },
            dtick:1,
            autorange: true,
            tickcolor: 'white',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)"
        },
        yaxis : {
            title: {
                text: 'Likelihood',        
                font: {
                    color: 'white'
                }
            },        
            range:  [0, 10],
            dtick:5,
            autorange: false,
            tickcolor: 'white',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)"
        },
        plot_bgcolor :"black",
        paper_bgcolor:"black"
    };
    const [layout_eigen, setEigenLayout] = useState(layout_eigen_init);
    let eigen_init = [{
        x: ['1','2','3','4','5','6','7','8'],
        y: [0,0,0,0,0,0,0,0],
        type: 'bar',
        name: 'L1',
        marker: {color: colorWhite}
    },{
        x: ['1','2','3','4','5','6','7','8'],
        y: [0,0,0,0,0,0,0,0],
        type: 'bar',
        name: 'L2',
        marker: {color: colorYellow}
    }];
    const [data_eigen, setEigenData] = useState(eigen_init);

    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            var localTime = new Date(SNStatus[props.index].Eigen.Time);
            var eigen = [{
                x: ['1','2','3','4','5','6','7','8'],
                y: [0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'L1',
                marker: {color: colorWhite}
            },{
                x: ['1','2','3','4','5','6','7','8'],
                y: [0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'L2',
                marker: {color: colorYellow}
            }];
            if(SNStatus[props.index].Eigen.Array.length > 0) {
                eigen[0].y = SNStatus[props.index].Eigen.Array[0].Eigen;
            }
            if(SNStatus[props.index].Eigen.Array.length > 1) {
                eigen[1].y = SNStatus[props.index].Eigen.Array[1].Eigen;
            }
            setEigenData(eigen);  
            let eigenLayout = layout_eigen;
            eigenLayout.title.text = SNStatus[props.index].Name + ' Likelihood of Interference Sources ' + localTime.toLocaleString();
            setEigenLayout(eigenLayout);
        } else {
            var eigen = [{
                x: ['1','2','3','4','5','6','7','8'],
                y: [0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'L1',
                marker: {color: colorWhite}
            },{
                x: ['1','2','3','4','5','6','7','8'],
                y: [0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'L2',
                marker: {color: colorYellow}
            }];
            setEigenData(eigen);  
            let eigenLayout = layout_eigen;
            eigenLayout.title.text = 'Likelihood of Interference Sources';
            setEigenLayout(eigenLayout);
        } 
    }, [SNTime, props.index]);
    
    return (
        <div>
            <Plot data={data_eigen as any} layout={layout_eigen} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
        </div>
    )
}
